module.exports = __webpack_public_path__ + "img/4626e02.jpg";